/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { CostCenterRestService } from '@gh/builder-shared-data';
import { FinderDialogConfig } from '@gh/common-internal-shared';
import { InitDialogViewService } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import {
  CostCenterFinderFilter,
  CostCenterFinderListItem,
} from './cost-center-finder-list-item.model';

export interface CostCenterFinderDialogConfig extends FinderDialogConfig {
  filter?: CostCenterFinderFilter;
}

@Injectable()
export class CostCenterFinderBusinessService implements InitDialogViewService<CostCenterFinderDialogConfig> {
  constructor(private restService: CostCenterRestService) {
  }

  initDialogView(): any {
    return {};
  }

  findAllAsDataSource(filter: CostCenterFinderFilter): SlicedDataSource<CostCenterFinderListItem> {
    return this.restService.findAllAsFinderDataSource(filter);
  }
}
